export default "/images/4-saisons.svg?1038fe18afdfc9b8e96e119166441b28";